/**
 * Volume discount drawer — open/close, progress bar, type switch, active row, quantity explorer.
 * Public API: cvdOpen(), cvdClose(), cvdUpdateProgress(qty), cvdUpdateExplorer(qty), cvdSwitchType(type, btnElement)
 */
(function () {
  'use strict';

  var config = null;
  var overlay = null;
  var drawer = null;
  var currentQty = 0;
  var currentUnitPrice = 0;

  function getConfig() {
    if (config) return config;
    var el = document.getElementById('cvd-drawer-config');
    if (!el || !el.textContent) return null;
    try {
      config = JSON.parse(el.textContent);
      return config;
    } catch (e) {
      return null;
    }
  }

  function getEl(id) {
    return document.getElementById(id);
  }

  function cvdOpen(openMethod) {
    overlay = overlay || document.getElementById('cvdOverlay');
    drawer = drawer || document.getElementById('cvdDrawer');
    if (!overlay || !drawer) return;
    overlay.classList.add('active');
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay.getAttribute('aria-hidden') !== null) {
      overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
    var trigger = document.querySelector('[data-cvd-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var firstFocus = drawer.querySelector('button[data-cvd-close], .cvd-type-btn');
    if (firstFocus) firstFocus.focus();
    if (window.jrsProductId && typeof window.jrsPDPTrack === 'function') {
      try {
        window.jrsCVDOpenTime = Date.now();
        window.jrsPDPTrack('pdp_cvd_drawer_open', {
          product_id: window.jrsProductId,
          open_method: openMethod || 'trigger_click',
          device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
        });
      } catch (e) { console.warn('GA4 CVD open track error', e); }
    }
    document.dispatchEvent(new CustomEvent('cvd-drawer-opened'));
  }

  var currentCvdType = 'garment';

  function cvdClose(closeMethod) {
    overlay = overlay || document.getElementById('cvdOverlay');
    drawer = drawer || document.getElementById('cvdDrawer');
    if (!overlay || !drawer) return;
    if (window.jrsProductId && typeof window.jrsPDPTrack === 'function' && window.jrsCVDOpenTime) {
      try {
        var timeOpen = Math.round((Date.now() - window.jrsCVDOpenTime) / 1000);
        window.jrsPDPTrack('pdp_cvd_drawer_close', {
          product_id: window.jrsProductId,
          close_method: closeMethod || 'button',
          time_open_seconds: timeOpen,
          device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
        });
      } catch (e) { console.warn('GA4 CVD close track error', e); }
    }
    overlay.classList.remove('active');
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var trigger = document.querySelector('[data-cvd-trigger]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  function getTierForQty(tiers, qty) {
    if (!tiers || !tiers.length) return null;
    var q = parseInt(qty, 10) || 0;
    for (var i = 0; i < tiers.length; i++) {
      if (q >= tiers[i].min && q <= tiers[i].max) return { tier: tiers[i], index: i };
    }
    if (q < tiers[0].min) return { tier: tiers[0], index: 0 };
    return { tier: tiers[tiers.length - 1], index: tiers.length - 1 };
  }

  function formatMoney(value, symbol) {
    symbol = symbol || '£';
    if (typeof value !== 'number' || isNaN(value)) return symbol + '0.00';
    return symbol + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function rebuildProgressBar(tiers, activeIndex) {
    var track = getEl('cvdProgressBar');
    var labelsContainer = getEl('cvdTierLabels');
    if (!track || !tiers || !tiers.length) return;
    track.innerHTML = '';
    labelsContainer.innerHTML = '';
    for (var i = 0; i < tiers.length; i++) {
      var seg = document.createElement('div');
      seg.className = 'cvd-progress-bar-segment';
      if (i < activeIndex) seg.classList.add('filled');
      else if (i === activeIndex) seg.classList.add('active');
      track.appendChild(seg);
      var lab = document.createElement('div');
      lab.className = 'cvd-progress-tier-label';
      lab.textContent = tiers[i].label || (tiers[i].min + (tiers[i].max >= 99999 ? '+' : '–' + tiers[i].max));
      if (i < activeIndex) lab.classList.add('filled');
      else if (i === activeIndex) lab.classList.add('active');
      labelsContainer.appendChild(lab);
    }
  }

  function rebuildNudge(tiers, activeIndex, qty, strings, symbol) {
    var container = getEl('cvdNudge');
    if (!container || !tiers || !tiers.length) return;
    container.innerHTML = '';
    var idx = activeIndex >= 0 ? activeIndex : 0;
    var currentTier = tiers[idx];
    var nextTier = tiers[idx + 1];
    if (nextTier && currentQty < nextTier.min) {
      var unitsToNext = nextTier.min - qty;
      var totalSavings = (currentTier.price - nextTier.price) * (qty + unitsToNext);
      var template = (strings && strings.nudgeTemplate) || 'Add {n} more to unlock {pct}% off at £{price}/unit — save £{savings} total';
      var savingsStr = totalSavings.toFixed(2);
      var text = template
        .replace(/\{n\}/g, unitsToNext)
        .replace(/\{pct\}/g, nextTier.discount)
        .replace(/\{price\}/g, nextTier.price.toFixed(2))
        .replace(/\{savings\}/g, savingsStr);
      var box = document.createElement('div');
      box.className = 'cvd-progress-nudge';
      var html = '<svg class="cvd-progress-nudge-icon" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 2V11M8 11L5 8M8 11L11 8" stroke="#E8601C" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 14H13" stroke="#E8601C" stroke-width="1.3" stroke-linecap="round"/></svg><span>' + text.replace('£' + savingsStr + ' total', '<span class="cvd-progress-nudge-savings">£' + savingsStr + ' total</span>') + '</span>';
      box.innerHTML = html;
      container.appendChild(box);
    } else {
      var maxed = document.createElement('div');
      maxed.className = 'cvd-progress-maxed';
      var msg = (strings && strings.maxedMessage) || "Maximum discount tier unlocked — you're getting the best price.";
      maxed.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1C3.7 1 1 3.7 1 7s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z" stroke="#15803D" stroke-width="1.2"/><path d="M4.5 7L6.5 9L10 5" stroke="#15803D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + msg + '</span>';
      container.appendChild(maxed);
    }
  }

  function highlightActiveRow(qty) {
    var table = getEl('cvdTable-garment');
    if (!table) return;
    var rows = table.querySelectorAll('.cvd-table-row[data-min][data-max]');
    var q = parseInt(qty, 10) || 0;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      var min = parseInt(r.getAttribute('data-min'), 10);
      var max = parseInt(r.getAttribute('data-max'), 10);
      r.classList.remove('active-tier');
      var badge = r.querySelector('.cvd-you-badge');
      if (badge) badge.remove();
      if (q >= min && q <= max) {
        r.classList.add('active-tier');
        var firstTd = r.querySelector('.cvd-table-td');
        if (firstTd) {
          var you = document.createElement('span');
          you.className = 'cvd-you-badge';
          you.textContent = 'YOU';
          firstTd.appendChild(you);
        }
      }
    }
    var activeRow = table.querySelector('.cvd-table-row.active-tier');
    if (activeRow) {
      var firstRow = table.querySelector('.cvd-table-row');
      if (firstRow && firstRow !== activeRow) {
        table.insertBefore(activeRow, firstRow);
      }
    }
  }

  function cvdUpdateProgress(qty) {
    var cfg = getConfig();
    if (!cfg || !cfg.tiers || !cfg.tiers.garment) return;
    currentQty = parseInt(qty, 10) || 0;
    var tiers = cfg.tiers.garment;
    var variantPrice = typeof cfg.variantPrice === 'number' ? cfg.variantPrice : parseFloat(cfg.variantPrice) || 0;
    currentUnitPrice = variantPrice;
    var result = getTierForQty(tiers, currentQty);
    var tier = result ? result.tier : tiers[0];
    var activeIndex = result ? result.index : 0;
    if (tier && typeof tier.price === 'number') {
      currentUnitPrice = tier.price;
    }

    var symbol = cfg.currencySymbol || '£';
    var currentEl = getEl('cvdCurrentPrice');
    var totalEl = getEl('cvdTotalValue');
    var badgeEl = getEl('cvdDiscountBadge');
    if (currentEl) currentEl.textContent = formatMoney(currentUnitPrice, symbol);
    if (totalEl) totalEl.textContent = formatMoney(currentQty * currentUnitPrice, symbol);
    if (badgeEl) {
      if (tier && tier.discount > 0) {
        badgeEl.textContent = tier.discount + '% off';
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    rebuildProgressBar(tiers, activeIndex);
    rebuildNudge(tiers, activeIndex, currentQty, cfg.strings, symbol);
    highlightActiveRow(currentQty);
    if (result && result.index !== lastCvdTierIndex && tier) {
      fireCvdTierReached(tier.label || (tier.min + (tier.max >= 99999 ? '+' : '–' + tier.max)), tier.min, tier.discount || 0);
      lastCvdTierIndex = result.index;
    }
  }

  function cvdSwitchType(type, btnElement) {
    var cfg = getConfig();
    if (!cfg) return;
    var types = ['garment', 'embroidery', 'print'];
    if (types.indexOf(type) === -1) return;
    var buttons = document.querySelectorAll('.cvd-type-btn');
    var tables = document.querySelectorAll('.cvd-table');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var t = b.getAttribute('data-cvd-type');
      b.classList.toggle('active', t === type);
      b.setAttribute('aria-pressed', t === type ? 'true' : 'false');
    }
    for (var j = 0; j < tables.length; j++) {
      var tbl = tables[j];
      var id = tbl.id || '';
      tbl.classList.toggle('active', id === 'cvdTable-' + type);
    }
    if (type === 'garment') {
      highlightActiveRow(currentQty);
    }
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }

  function setupSwipeToClose() {
    var dr = document.getElementById('cvdDrawer');
    if (!dr) return;
    var handleEl = dr.querySelector('.cvd-drawer-handle');
    var scrollEl = dr.querySelector('.cvd-drawer-body');
    if (!scrollEl) return;
    var swipeThreshold = 80;
    var touchStartY = 0;
    var touchStartedOnHandle = false;
    var isSwipeClosing = false;

    function handleTouchStart(e) {
      if (e.target.closest('button, a, input, select, textarea')) return;
      touchStartY = e.touches[0].clientY;
      touchStartedOnHandle = handleEl && handleEl.contains(e.target);
      isSwipeClosing = false;
    }

    function handleTouchMove(e) {
      if (!dr.classList.contains('active') || !isMobile()) return;
      var currentY = e.touches[0].clientY;
      var deltaY = currentY - touchStartY;
      var isAtTop = scrollEl.scrollTop <= 0;
      var allowSwipe = touchStartedOnHandle || (isAtTop && deltaY > 0);
      if (allowSwipe && deltaY > 0) {
        e.preventDefault();
        isSwipeClosing = true;
        var progress = Math.min(deltaY / (swipeThreshold * 2), 1);
        dr.style.transition = 'none';
        dr.style.transform = 'translateY(' + (deltaY * 0.5) + 'px) scale(' + (1 - progress * 0.03) + ')';
      } else if (isSwipeClosing && deltaY <= 0) {
        isSwipeClosing = false;
        dr.style.transition = '';
        dr.style.transform = '';
      }
    }

    function handleTouchEnd(e) {
      if (!isSwipeClosing) return;
      var currentY = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : touchStartY;
      var deltaY = currentY - touchStartY;
      dr.style.transition = '';
      dr.style.transform = '';
      if (deltaY > swipeThreshold) {
        cvdClose();
      }
      isSwipeClosing = false;
    }

    dr.addEventListener('touchstart', handleTouchStart, { passive: true });
    dr.addEventListener('touchmove', handleTouchMove, { passive: false });
    dr.addEventListener('touchend', handleTouchEnd, { passive: true });
  }

  function bind() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cvd-trigger]')) {
        e.preventDefault();
        var triggerEl = e.target.closest('[data-cvd-trigger]');
        if (window.jrsProductId && typeof window.jrsPDPTrack === 'function') {
          try {
            var triggerLabel = (triggerEl && triggerEl.querySelector('.cvd-trigger-label')) ? triggerEl.querySelector('.cvd-trigger-label').textContent : 'Volume pricing';
            window.jrsPDPTrack('pdp_cvd_trigger_click', {
              product_id: window.jrsProductId,
              trigger_label: (triggerLabel || '').trim(),
              device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
            });
          } catch (err) { console.warn('GA4 CVD trigger click error', err); }
        }
        cvdOpen('trigger_click');
        return;
      }
      if (e.target.closest('[data-cvd-close]')) {
        cvdClose('button');
        return;
      }
      if (e.target.id === 'cvdOverlay') {
        cvdClose('overlay');
        return;
      }
      var typeBtn = e.target.closest('.cvd-type-btn[data-cvd-type]');
      if (typeBtn) {
        var type = typeBtn.getAttribute('data-cvd-type');
        if (window.jrsProductId && typeof window.jrsPDPTrack === 'function') {
          try {
            window.jrsPDPTrack('pdp_cvd_type_switch', {
              product_id: window.jrsProductId,
              from_type: currentCvdType,
              to_type: type,
              device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
            });
          } catch (err) { console.warn('GA4 CVD type switch error', err); }
          currentCvdType = type;
        }
        cvdSwitchType(type, typeBtn);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var dr = document.getElementById('cvdDrawer');
        if (dr && dr.classList.contains('active')) {
          cvdClose('esc');
        }
      }
    });
  }

  var explorerRefs = {};
  var lastCvdTierIndex = -1;

  function fireCvdQuantityChange(inputMethod, quantityValue) {
    if (!window.jrsProductId || typeof window.jrsPDPTrack !== 'function') return;
    try {
      var cfg = getConfig();
      var tierLabel = '';
      var tierReached = false;
      if (cfg && cfg.tiers && cfg.tiers.garment) {
        var res = getTierForQty(cfg.tiers.garment, quantityValue);
        if (res) {
          tierLabel = res.tier.label || (res.tier.min + (res.tier.max >= 99999 ? '+' : '-' + res.tier.max));
          tierReached = true;
        }
      }
      window.jrsPDPTrack('pdp_cvd_quantity_change', {
        product_id: window.jrsProductId,
        input_method: inputMethod,
        quantity_value: quantityValue,
        tier_reached: tierLabel,
        device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
      });
    } catch (e) { console.warn('GA4 CVD quantity change error', e); }
  }

  function fireCvdTierReached(tierLabel, minQty, discountPercent) {
    if (!window.jrsProductId || typeof window.jrsPDPTrack !== 'function') return;
    try {
      window.jrsPDPTrack('pdp_cvd_tier_reached', {
        product_id: window.jrsProductId,
        tier_label: tierLabel,
        min_qty: minQty,
        discount_percent: discountPercent,
        device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
      });
    } catch (e) { console.warn('GA4 CVD tier reached error', e); }
  }

  function getExplorerRefs() {
    var container = document.querySelector('.cvd-explorer');
    if (!container) return null;
    return {
      container: container,
      stepperInput: container.querySelector('.cvd-explorer-stepper-input'),
      slider: container.querySelector('.cvd-explorer-slider'),
      sliderFill: container.querySelector('.cvd-explorer-slider-fill'),
      ticks: container.querySelectorAll('.cvd-explorer-slider-tick'),
      tierMarkers: container.querySelectorAll('.cvd-explorer-tier-marker'),
      quickpicks: container.querySelectorAll('.cvd-explorer-quickpick')
    };
  }

  function updateTickColors(qty, refs, sliderMax) {
    if (!refs || !refs.ticks.length) return;
    var q = parseInt(qty, 10) || 0;
    for (var i = 0; i < refs.ticks.length; i++) {
      var tick = refs.ticks[i];
      var min = parseInt(tick.getAttribute('data-tier-min'), 10) || 0;
      tick.classList.toggle('reached', q >= min);
    }
  }

  function updateTierMarkers(qty, refs, tiers) {
    if (!refs || !refs.tierMarkers.length) return;
    var q = parseInt(qty, 10) || 0;
    var tierIndex = -1;
    if (tiers && tiers.length) {
      for (var i = 0; i < tiers.length; i++) {
        if (q >= tiers[i].min && q <= tiers[i].max) {
          tierIndex = i;
          break;
        }
        if (q < tiers[i].min) break;
        tierIndex = i;
      }
      if (tierIndex < 0 && tiers.length) tierIndex = 0;
    }
    for (var j = 0; j < refs.tierMarkers.length; j++) {
      var btn = refs.tierMarkers[j];
      var min = parseInt(btn.getAttribute('data-qty'), 10) || 0;
      btn.classList.remove('past', 'active');
      if (tiers && tiers.length) {
        var idx = -1;
        for (var k = 0; k < tiers.length; k++) {
          if (min >= tiers[k].min && min <= tiers[k].max) {
            idx = k;
            break;
          }
        }
        if (idx >= 0) {
          if (idx < tierIndex) btn.classList.add('past');
          else if (idx === tierIndex) btn.classList.add('active');
        }
      }
    }
  }

  function updateQuickPicks(qty, refs, tiers) {
    if (!refs || !refs.quickpicks.length) return;
    var q = parseInt(qty, 10) || 0;
    var currentTierIndex = -1;
    if (tiers && tiers.length) {
      for (var i = 0; i < tiers.length; i++) {
        if (q >= tiers[i].min && q <= tiers[i].max) {
          currentTierIndex = i;
          break;
        }
        if (q < tiers[i].min) break;
        currentTierIndex = i;
      }
      if (currentTierIndex < 0) currentTierIndex = 0;
    }
    for (var j = 0; j < refs.quickpicks.length; j++) {
      var btn = refs.quickpicks[j];
      var val = parseInt(btn.getAttribute('data-qty'), 10) || 0;
      btn.classList.remove('active');
      if (tiers && tiers.length && currentTierIndex >= 0) {
        for (var k = 0; k < tiers.length; k++) {
          if (val >= tiers[k].min && val <= tiers[k].max) {
            if (k === currentTierIndex) btn.classList.add('active');
            break;
          }
        }
      }
    }
  }

  function cvdUpdateExplorer(qty) {
    var cfg = getConfig();
    if (!cfg) return;
    var q = parseInt(qty, 10);
    if (isNaN(q) || q < 1) q = 1;
    if (q > 9999) q = 9999;
    var sliderMax = (cfg.sliderMax !== undefined && cfg.sliderMax > 0) ? cfg.sliderMax : 600;
    var refs = explorerRefs.container ? explorerRefs : getExplorerRefs();
    if (!refs || !refs.container) return;
    explorerRefs = refs;

    if (refs.stepperInput) {
      refs.stepperInput.value = String(q);
      refs.stepperInput.setAttribute('aria-valuenow', String(q));
    }
    if (refs.slider) {
      var sliderVal = Math.min(q, sliderMax);
      refs.slider.value = String(sliderVal);
      refs.slider.setAttribute('aria-valuenow', String(sliderVal));
    }
    if (refs.sliderFill) {
      var pct = (q / sliderMax) * 100;
      refs.sliderFill.style.width = pct + '%';
    }
    updateTickColors(q, refs, sliderMax);
    updateTierMarkers(q, refs, cfg.tiers && cfg.tiers.garment ? cfg.tiers.garment : null);
    updateQuickPicks(q, refs, cfg.tiers && cfg.tiers.garment ? cfg.tiers.garment : null);
    cvdUpdateProgress(q);
  }

  function bindQuantityExplorer() {
    var cfg = getConfig();
    if (!cfg || !cfg.showSimulator) return;
    var refs = getExplorerRefs();
    if (!refs || !refs.container) return;
    explorerRefs = refs;

    var sliderMax = (cfg.sliderMax !== undefined && cfg.sliderMax > 0) ? cfg.sliderMax : 600;
    if (refs.slider) {
      refs.slider.setAttribute('max', String(sliderMax));
    }

    var stepperMinus = refs.container.querySelector('.cvd-explorer-stepper-btn.minus');
    var stepperPlus = refs.container.querySelector('.cvd-explorer-stepper-btn.plus');

    if (stepperMinus) {
      stepperMinus.addEventListener('click', function () {
        var cur = parseInt(refs.stepperInput.value, 10) || 1;
        var newQty = cur - 1;
        cvdUpdateExplorer(newQty);
        fireCvdQuantityChange('stepper', newQty);
      });
    }
    if (stepperPlus) {
      stepperPlus.addEventListener('click', function () {
        var cur = parseInt(refs.stepperInput.value, 10) || 1;
        var newQty = cur + 1;
        cvdUpdateExplorer(newQty);
        fireCvdQuantityChange('stepper', newQty);
      });
    }
    if (refs.stepperInput) {
      refs.stepperInput.addEventListener('input', function () {
        var val = refs.stepperInput.value.trim();
        if (val === '') return;
        var num = parseInt(val, 10);
        if (!isNaN(num) && num >= 1) {
          cvdUpdateExplorer(num);
          fireCvdQuantityChange('stepper', num);
        }
      });
      refs.stepperInput.addEventListener('blur', function () {
        var val = refs.stepperInput.value.trim();
        var num = parseInt(val, 10);
        if (val === '' || isNaN(num) || num < 1) {
          cvdUpdateExplorer(1);
          fireCvdQuantityChange('stepper', 1);
        } else if (num > 9999) {
          cvdUpdateExplorer(9999);
          fireCvdQuantityChange('stepper', 9999);
        }
      });
    }
    if (refs.slider) {
      refs.slider.addEventListener('input', function () {
        var q = parseInt(refs.slider.value, 10);
        cvdUpdateExplorer(q);
        fireCvdQuantityChange('slider', q);
      });
    }
    for (var i = 0; i < refs.tierMarkers.length; i++) {
      refs.tierMarkers[i].addEventListener('click', function () {
        var q = parseInt(this.getAttribute('data-qty'), 10);
        if (!isNaN(q)) {
          cvdUpdateExplorer(q);
          fireCvdQuantityChange('quick_pick', q);
        }
      });
    }
    for (var k = 0; k < refs.quickpicks.length; k++) {
      refs.quickpicks[k].addEventListener('click', function () {
        var q = parseInt(this.getAttribute('data-qty'), 10);
        if (!isNaN(q)) {
          if (window.jrsProductId && typeof window.jrsPDPTrack === 'function') {
            try {
              window.jrsPDPTrack('pdp_cvd_quick_pick_click', {
                product_id: window.jrsProductId,
                quick_pick_value: q,
                device_type: typeof jrsDeviceType === 'function' ? jrsDeviceType() : (window.innerWidth <= 768 ? 'mobile' : 'desktop')
              });
            } catch (err) { console.warn('GA4 CVD quick pick click error', err); }
          }
          cvdUpdateExplorer(q);
          fireCvdQuantityChange('quick_pick', q);
        }
      });
    }

    var initialQty = 1;
    cvdUpdateExplorer(initialQty);
  }

  function init() {
    getConfig();
    overlay = document.getElementById('cvdOverlay');
    drawer = document.getElementById('cvdDrawer');
    if (!drawer) return;
    bind();
    setupSwipeToClose();
    bindQuantityExplorer();
    var cfg = getConfig();
    if (!cfg || !cfg.showSimulator || !document.querySelector('.cvd-explorer')) {
      if (currentQty === 0) cvdUpdateProgress(1);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.cvdOpen = cvdOpen;
  window.cvdClose = cvdClose;
  window.cvdUpdateProgress = cvdUpdateProgress;
  window.cvdUpdateExplorer = cvdUpdateExplorer;
  window.cvdSwitchType = cvdSwitchType;
})();
